import { Navigate } from 'react-router-dom';

export function WindexConnectPage() {
  return <Navigate to="/integrations" replace />;
}
